import React, { createContext, useState, useEffect,useMemo} from 'react';
import intl from 'react-intl-universal';

const locales = {
  en: require('./locales/localesLang/en-US.json'),
  zh: require('./locales/localesLang/zh-CN.json'),
};

export const LocaleContext = createContext();

export const LocaleProvider = ({ children }) => {
  const [locale, setLocale] = useState(localStorage.getItem("locale") || "zh");
  const [initDone, setInitDone] = useState(false);

  useEffect(() => {
    loadLocales(locale);
  }, [locale]);

  const loadLocales = (lang) => {
    intl.init({
      currentLocale: lang,
      locales,
    }).then(() => {
      setInitDone(true);
    });
  };

  const toggleLocale = (lang) => {
    setLocale(lang);
    localStorage.setItem("locale", lang);
  };
  const obj = useMemo(() => ({ locale, toggleLocale, initDone }), []);
  return (
    <LocaleContext.Provider value={obj}>
      {initDone && children}
    </LocaleContext.Provider>
  );
};